import { render, staticRenderFns } from "./TestResult.vue?vue&type=template&id=fed8ad52&"
import script from "./TestResult.vue?vue&type=script&lang=js&"
export * from "./TestResult.vue?vue&type=script&lang=js&"
import style0 from "./TestResult.vue?vue&type=style&index=0&id=fed8ad52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports